var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ],
      staticClass: "Edit"
    },
    [
      _c(
        "el-header",
        { staticClass: "Edit-header" },
        [
          _c("el-page-header", {
            attrs: { content: _vm.title },
            on: { back: _vm.close }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-main",
        { staticClass: "Edit-main" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "150px",
                disabled: _vm.disableEdit
              }
            },
            [
              _vm.isSspUser
                ? _c(
                    "el-form-item",
                    { attrs: { label: "所属广告主", prop: "advertiserId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { disabled: _vm.isModel === 2 },
                          on: { change: _vm.setUser },
                          model: {
                            value: _vm.form.advertiserId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "advertiserId", $$v)
                            },
                            expression: "form.advertiserId"
                          }
                        },
                        _vm._l(_vm.userList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.advertiserName,
                              value: item.advertiserId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "创意名称", prop: "ideaName" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.ideaName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "ideaName", $$v)
                      },
                      expression: "form.ideaName"
                    }
                  }),
                  _vm._v(" "),
                  _c("ChangeTips", { attrs: { change: _vm.changes.ideaName } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "投放单元", prop: "unit" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "380px" },
                      attrs: { disabled: _vm.isModel === 2, filterable: "" },
                      on: { change: _vm.setUnit },
                      model: {
                        value: _vm.form.unit,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "unit", $$v)
                        },
                        expression: "form.unit"
                      }
                    },
                    _vm._l(_vm.unitList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.putUnitName,
                          value: item.putUnitId
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("ChangeTips", { attrs: { change: _vm.changes.unit } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "创意类型", prop: "ideaType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "380px" },
                      attrs: { disabled: _vm.isModel === 2, filterable: "" },
                      on: { change: _vm.setIdeaType },
                      model: {
                        value: _vm.form.ideaType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "ideaType", $$v)
                        },
                        expression: "form.ideaType"
                      }
                    },
                    _vm._l(_vm.ideaTypeList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.ideaTypeName,
                          value: item.ideaTypeId
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("ChangeTips", { attrs: { change: _vm.changes.ideaType } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "出价类型", prop: "bidType" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.bidType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "bidType", $$v)
                        },
                        expression: "form.bidType"
                      }
                    },
                    _vm._l(_vm.bidTypeList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("ChangeTips", { attrs: { change: _vm.changes.bidType } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "目标出价", prop: "simulateBid" }
                },
                [
                  _c(
                    "el-input",
                    {
                      model: {
                        value: _vm.form.simulateBid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "simulateBid", $$v)
                        },
                        expression: "form.simulateBid"
                      }
                    },
                    [
                      _c("template", { slot: "append" }, [
                        _vm._v(
                          "元" +
                            _vm._s(
                              _vm.form.bidType === 2
                                ? " / 点击"
                                : _vm.form.bidType === 3
                                ? " / 千次展示"
                                : _vm.form.bidType === 4 ||
                                  _vm.form.bidType === 5
                                ? " / 用户成本"
                                : ""
                            )
                        )
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("ChangeTips", {
                    attrs: { change: _vm.changes.simulateBid }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.assetsList, function(item, index) {
                return [
                  item.assetsId === 1
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请选择Icon图片",
                                trigger: "change"
                              }
                            ],
                            label: "Icon",
                            prop: "iconFile",
                            error: _vm.iconErrorTip
                          }
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "file_img" }, [
                              _c(
                                "div",
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: _vm.iconPreview,
                                      "preview-src-list": [_vm.iconPreview]
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("div", [
                                    _c("input", {
                                      ref: "file_icon",
                                      refInFor: true,
                                      attrs: {
                                        type: "file",
                                        accept: item.data.mimes.join(","),
                                        title: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.setImg(
                                            $event,
                                            "icon",
                                            item.data
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  上传\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.iconPreview
                                    ? [
                                        _vm.isModel === 2
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.iconPreview,
                                                  download: ""
                                                }
                                              },
                                              [_vm._v("下载")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("el-button", {
                                          attrs: {
                                            size: "small",
                                            icon: "el-icon-close"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeImg("icon")
                                            }
                                          }
                                        })
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "file_taps" }, [
                              _vm._v(
                                "Icon仅限 " +
                                  _vm._s(
                                    item.data.mimes
                                      .join("、")
                                      .replace(/image\//g, "")
                                      .toUpperCase()
                                  ) +
                                  " 格式，宽度：" +
                                  _vm._s(
                                    item.data.width ? item.data.width : "不限"
                                  ) +
                                  "，高度：" +
                                  _vm._s(
                                    item.data.height ? item.data.height : "不限"
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.icon }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 2
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请选择Logo图片",
                                trigger: "change"
                              }
                            ],
                            label: "Logo",
                            prop: "logoFile",
                            error: _vm.logoErrorTip
                          }
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "file_img" }, [
                              _c(
                                "div",
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: _vm.logoPreview,
                                      "preview-src-list": [_vm.logoPreview]
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("div", [
                                    _c("input", {
                                      ref: "file_logo",
                                      refInFor: true,
                                      attrs: {
                                        type: "file",
                                        accept: item.data.mimes.join(","),
                                        title: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.setImg(
                                            $event,
                                            "logo",
                                            item.data
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  上传\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.logoPreview
                                    ? [
                                        _vm.isModel === 2
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.logoPreview,
                                                  download: ""
                                                }
                                              },
                                              [_vm._v("下载")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("el-button", {
                                          attrs: {
                                            size: "small",
                                            icon: "el-icon-close"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeImg("logo")
                                            }
                                          }
                                        })
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "file_taps" }, [
                              _vm._v(
                                "Logo仅限 " +
                                  _vm._s(
                                    item.data.mimes
                                      .join("、")
                                      .replace(/image\//g, "")
                                      .toUpperCase()
                                  ) +
                                  " 格式，宽度：" +
                                  _vm._s(
                                    item.data.width ? item.data.width : "不限"
                                  ) +
                                  "，高度：" +
                                  _vm._s(
                                    item.data.height ? item.data.height : "不限"
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.logo }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 3
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请选择主图片",
                                trigger: "change"
                              }
                            ],
                            label: "主图片",
                            prop: "image1File",
                            error: _vm.image1ErrorTip
                          }
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "file_img" }, [
                              _c(
                                "div",
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: _vm.image1Preview,
                                      "preview-src-list": [_vm.image1Preview]
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("div", [
                                    _c("input", {
                                      ref: "file_image1",
                                      refInFor: true,
                                      attrs: {
                                        type: "file",
                                        accept: item.data.mimes.join(","),
                                        title: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.setImg(
                                            $event,
                                            "image1",
                                            item.data
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  上传\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.image1Preview
                                    ? [
                                        _vm.isModel === 2
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.image1Preview,
                                                  download: ""
                                                }
                                              },
                                              [_vm._v("下载")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("el-button", {
                                          attrs: {
                                            size: "small",
                                            icon: "el-icon-close"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeImg("image1")
                                            }
                                          }
                                        })
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "file_taps" }, [
                              _vm._v(
                                "主图片仅限 " +
                                  _vm._s(
                                    item.data.mimes
                                      .join("、")
                                      .replace(/image\//g, "")
                                      .toUpperCase()
                                  ) +
                                  " 格式，宽度：" +
                                  _vm._s(
                                    item.data.width ? item.data.width : "不限"
                                  ) +
                                  "，高度：" +
                                  _vm._s(
                                    item.data.height ? item.data.height : "不限"
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.image1 }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 4
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请选择图片二",
                                trigger: "change"
                              }
                            ],
                            label: "图片二",
                            prop: "image2File",
                            error: _vm.image2ErrorTip
                          }
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "file_img" }, [
                              _c(
                                "div",
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: _vm.image2Preview,
                                      "preview-src-list": [_vm.image2Preview]
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("div", [
                                    _c("input", {
                                      ref: "file_image2",
                                      refInFor: true,
                                      attrs: {
                                        type: "file",
                                        accept: item.data.mimes.join(","),
                                        title: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.setImg(
                                            $event,
                                            "image2",
                                            item.data
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  上传\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.image2Preview
                                    ? [
                                        _vm.isModel === 2
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.image2Preview,
                                                  download: ""
                                                }
                                              },
                                              [_vm._v("下载")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("el-button", {
                                          attrs: {
                                            size: "small",
                                            icon: "el-icon-close"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeImg("image2")
                                            }
                                          }
                                        })
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "file_taps" }, [
                              _vm._v(
                                "图片二仅限 " +
                                  _vm._s(
                                    item.data.mimes
                                      .join("、")
                                      .replace(/image\//g, "")
                                      .toUpperCase()
                                  ) +
                                  " 格式，宽度：" +
                                  _vm._s(
                                    item.data.width ? item.data.width : "不限"
                                  ) +
                                  "，高度：" +
                                  _vm._s(
                                    item.data.height ? item.data.height : "不限"
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.image2 }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 5
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请选择图片三",
                                trigger: "change"
                              }
                            ],
                            label: "图片三",
                            prop: "image3File",
                            error: _vm.image3ErrorTip
                          }
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "file_img" }, [
                              _c(
                                "div",
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: _vm.image3Preview,
                                      "preview-src-list": [_vm.image3Preview]
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("div", [
                                    _c("input", {
                                      ref: "file_image3",
                                      refInFor: true,
                                      attrs: {
                                        type: "file",
                                        accept: item.data.mimes.join(","),
                                        title: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.setImg(
                                            $event,
                                            "image3",
                                            item.data
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  上传\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.image3Preview
                                    ? [
                                        _vm.isModel === 2
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.image3Preview,
                                                  download: ""
                                                }
                                              },
                                              [_vm._v("下载")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("el-button", {
                                          attrs: {
                                            size: "small",
                                            icon: "el-icon-close"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeImg("image3")
                                            }
                                          }
                                        })
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "file_taps" }, [
                              _vm._v(
                                "图片三仅限 " +
                                  _vm._s(
                                    item.data.mimes
                                      .join("、")
                                      .replace(/image\//g, "")
                                      .toUpperCase()
                                  ) +
                                  " 格式，宽度：" +
                                  _vm._s(
                                    item.data.width ? item.data.width : "不限"
                                  ) +
                                  "，高度：" +
                                  _vm._s(
                                    item.data.height ? item.data.height : "不限"
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.image3 }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 6
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入标题",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "标题",
                            prop: "title"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.title,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "title", $$v)
                              },
                              expression: "form.title"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.title }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 7
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入描述",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "描述",
                            prop: "desc"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.desc,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "desc", $$v)
                              },
                              expression: "form.desc"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.desc }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 8
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入评分",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "评分",
                            prop: "rating"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.rating,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "rating", $$v)
                              },
                              expression: "form.rating"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.rating }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 9
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入好评数",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "好评数",
                            prop: "comments"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.comments,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "comments", $$v)
                              },
                              expression: "form.comments"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.comments }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 10
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入落地页链接",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "落地页链接",
                            prop: "targetUrl"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "url" },
                            model: {
                              value: _vm.form.targetUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "targetUrl", $$v)
                              },
                              expression: "form.targetUrl"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.targetUrl }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 11
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入APP名称",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "APP名称",
                            prop: "appName"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.appName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "appName", $$v)
                              },
                              expression: "form.appName"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.appName }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 12
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入APP下载链接",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "APP下载链接",
                            prop: "appDownUrl"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "url" },
                            model: {
                              value: _vm.form.appDownUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "appDownUrl", $$v)
                              },
                              expression: "form.appDownUrl"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.appDownUrl }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 13
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入打开应用URL",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "打开应用URL",
                            prop: "deeplink"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "url" },
                            model: {
                              value: _vm.form.deeplink,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "deeplink", $$v)
                              },
                              expression: "form.deeplink"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.deeplink }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 14
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入APP包名",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "APP包名",
                            prop: "packageName"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.packageName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "packageName", $$v)
                              },
                              expression: "form.packageName"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.packageName }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 15
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          class: { "is-required": !!item.required },
                          staticStyle: {
                            width: "500px",
                            "margin-bottom": "80px"
                          },
                          attrs: {
                            label: "展示监控",
                            prop: "showMonitor",
                            error: _vm.showMonitorTip
                          }
                        },
                        [
                          _vm._l(_vm.form.showMonitor, function(item1, index1) {
                            return _c(
                              "el-input",
                              {
                                key: index1,
                                staticClass: "mt10",
                                on: {
                                  blur: function($event) {
                                    return _vm.urlRule(
                                      "showMonitor",
                                      "展示监控",
                                      index1,
                                      {
                                        required: !!item.required,
                                        min: item.data.minLen,
                                        max: item.data.maxLen
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.showMonitor[index1],
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.showMonitor, index1, $$v)
                                  },
                                  expression: "form.showMonitor[index1]"
                                }
                              },
                              [
                                index1 > 0
                                  ? _c("el-button", {
                                      attrs: {
                                        slot: "append",
                                        icon: "el-icon-close"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteValue(
                                            "showMonitor",
                                            index1
                                          )
                                        }
                                      },
                                      slot: "append"
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "-60px",
                                left: "0"
                              },
                              attrs: { type: "primary", plain: "" },
                              on: {
                                click: function($event) {
                                  return _vm.setUrlInput("showMonitor")
                                }
                              }
                            },
                            [_vm._v("添加URL")]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              position: "absolute",
                              top: "12px",
                              left: "101%",
                              "font-size": "20px",
                              cursor: "pointer"
                            },
                            attrs: { title: "点击查看宏参数列表" },
                            on: {
                              click: function($event) {
                                return _vm.openMacroDialog(true)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.showMonitor }
                          })
                        ],
                        2
                      )
                    : item.assetsId === 16
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          class: { "is-required": !!item.required },
                          staticStyle: {
                            width: "500px",
                            "margin-bottom": "80px"
                          },
                          attrs: {
                            label: "点击监控",
                            prop: "clickMonitor",
                            error: _vm.clickMonitorTip
                          }
                        },
                        [
                          _vm._l(_vm.form.clickMonitor, function(
                            item1,
                            index1
                          ) {
                            return _c(
                              "el-input",
                              {
                                key: index1,
                                staticClass: "mt10",
                                on: {
                                  blur: function($event) {
                                    return _vm.urlRule(
                                      "clickMonitor",
                                      "展示监控",
                                      index1,
                                      {
                                        required: !!item.required,
                                        min: item.data.minLen,
                                        max: item.data.maxLen
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.clickMonitor[index1],
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.clickMonitor, index1, $$v)
                                  },
                                  expression: "form.clickMonitor[index1]"
                                }
                              },
                              [
                                index1 > 0
                                  ? _c("el-button", {
                                      attrs: {
                                        slot: "append",
                                        icon: "el-icon-close"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteValue(
                                            "clickMonitor",
                                            index1
                                          )
                                        }
                                      },
                                      slot: "append"
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "-60px",
                                left: "0"
                              },
                              attrs: { type: "primary", plain: "" },
                              on: {
                                click: function($event) {
                                  return _vm.setUrlInput("clickMonitor")
                                }
                              }
                            },
                            [_vm._v("添加URL")]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              position: "absolute",
                              top: "12px",
                              left: "101%",
                              "font-size": "20px",
                              cursor: "pointer"
                            },
                            attrs: { title: "点击查看宏参数列表" },
                            on: {
                              click: function($event) {
                                return _vm.openMacroDialog(false)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.clickMonitor }
                          })
                        ],
                        2
                      )
                    : item.assetsId === 17
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请选择视频",
                                trigger: "change"
                              }
                            ],
                            label: "视频",
                            prop: "video",
                            error: _vm.videoErrorTip
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "file el-input__inner",
                                  attrs: { href: "javascript:;" }
                                },
                                [
                                  _vm.videoPreview
                                    ? _c(
                                        "video",
                                        {
                                          staticClass: "img_preview",
                                          attrs: {
                                            src: _vm.videoPreview,
                                            width: "100%",
                                            height: "auto",
                                            muted: "",
                                            autoplay: "",
                                            loop: ""
                                          },
                                          domProps: { muted: true }
                                        },
                                        [_vm._v("您的浏览器不支持 video 标签")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("input", {
                                    attrs: {
                                      type: "file",
                                      accept: item.data.mimes.join(","),
                                      title: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.setVideo($event, item.data)
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("el-button", {
                                attrs: { icon: "el-icon-close" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeVideo()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "file_taps" }, [
                                _vm._v(
                                  "视频仅限 " +
                                    _vm._s(
                                      item.data.mimes
                                        .join("、")
                                        .replace(/video\//g, "")
                                        .toUpperCase()
                                    ) +
                                    " 格式，宽度：" +
                                    _vm._s(
                                      item.data.width ? item.data.width : "不限"
                                    ) +
                                    "，高度：" +
                                    _vm._s(
                                      item.data.height
                                        ? item.data.height
                                        : "不限"
                                    ) +
                                    "，最小时长：" +
                                    _vm._s(
                                      item.data.minTime
                                        ? item.data.minTime
                                        : "不限"
                                    ) +
                                    "，最大时长：" +
                                    _vm._s(
                                      item.data.maxTime
                                        ? item.data.maxTime
                                        : "不限"
                                    )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.video }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 18
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入APP版本",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "APP版本",
                            prop: "appVersion"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.appVersion,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "appVersion", $$v)
                              },
                              expression: "form.appVersion"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.appVersion }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 19
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入APP开发者",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "APP开发者",
                            prop: "appDeveloper"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.appDeveloper,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "appDeveloper", $$v)
                              },
                              expression: "form.appDeveloper"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.appDeveloper }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 20
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入APP功能描述URL",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "APP功能描述URL",
                            prop: "appFeatureUrl"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.appFeatureUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "appFeatureUrl", $$v)
                              },
                              expression: "form.appFeatureUrl"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.appFeatureUrl }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 21
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入APP隐私政策URL",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "APP隐私政策URL",
                            prop: "appPrivacyPolicyUrl"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.appPrivacyPolicyUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "appPrivacyPolicyUrl", $$v)
                              },
                              expression: "form.appPrivacyPolicyUrl"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.appPrivacyPolicyUrl }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 22
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          staticStyle: { width: "500px" },
                          attrs: {
                            rules: [
                              {
                                required: !!item.required,
                                message: "请输入APP权限列表URL",
                                trigger: "blur"
                              },
                              {
                                min: item.data.minLen
                                  ? parseInt(item.data.minLen)
                                  : 0,
                                max: item.data.maxLen
                                  ? parseInt(item.data.maxLen)
                                  : _vm.maxfontNumber,
                                message:
                                  "长度在 " +
                                  (item.data.minLen ? item.data.minLen : 0) +
                                  " 到 " +
                                  (item.data.maxLen
                                    ? item.data.maxLen
                                    : _vm.maxfontNumber) +
                                  " 个字符",
                                trigger: "blur"
                              }
                            ],
                            label: "APP权限列表URL",
                            prop: "appPermissionUrl"
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.appPermissionUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "appPermissionUrl", $$v)
                              },
                              expression: "form.appPermissionUrl"
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.appPermissionUrl }
                          })
                        ],
                        1
                      )
                    : item.assetsId === 23
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          class: { "is-required": !!item.required },
                          staticStyle: {
                            width: "500px",
                            "margin-bottom": "80px"
                          },
                          attrs: {
                            label: "下载开始监控",
                            prop: "downloadStartMonitor",
                            error: _vm.downloadStartMonitorTip
                          }
                        },
                        [
                          _vm._l(_vm.form.downloadStartMonitor, function(
                            item1,
                            index1
                          ) {
                            return _c(
                              "el-input",
                              {
                                key: index1,
                                staticClass: "mt10",
                                on: {
                                  blur: function($event) {
                                    return _vm.urlRule(
                                      "downloadStartMonitor",
                                      "下载开始监控",
                                      index1,
                                      {
                                        required: !!item.required,
                                        min: item.data.minLen,
                                        max: item.data.maxLen
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.downloadStartMonitor[index1],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.downloadStartMonitor,
                                      index1,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.downloadStartMonitor[index1]"
                                }
                              },
                              [
                                index1 > 0
                                  ? _c("el-button", {
                                      attrs: {
                                        slot: "append",
                                        icon: "el-icon-close"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteValue(
                                            "downloadStartMonitor",
                                            index1
                                          )
                                        }
                                      },
                                      slot: "append"
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "-60px",
                                left: "0"
                              },
                              attrs: { type: "primary", plain: "" },
                              on: {
                                click: function($event) {
                                  return _vm.setUrlInput("downloadStartMonitor")
                                }
                              }
                            },
                            [_vm._v("添加URL")]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              position: "absolute",
                              top: "12px",
                              left: "101%",
                              "font-size": "20px",
                              cursor: "pointer"
                            },
                            attrs: { title: "点击查看宏参数列表" },
                            on: {
                              click: function($event) {
                                return _vm.openMacroDialog(false)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.downloadStartMonitor }
                          })
                        ],
                        2
                      )
                    : item.assetsId === 24
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          class: { "is-required": !!item.required },
                          staticStyle: {
                            width: "500px",
                            "margin-bottom": "80px"
                          },
                          attrs: {
                            label: "下载完成监控",
                            prop: "downloadFinishMonitor",
                            error: _vm.downloadFinishMonitorTip
                          }
                        },
                        [
                          _vm._l(_vm.form.downloadFinishMonitor, function(
                            item1,
                            index1
                          ) {
                            return _c(
                              "el-input",
                              {
                                key: index1,
                                staticClass: "mt10",
                                on: {
                                  blur: function($event) {
                                    return _vm.urlRule(
                                      "downloadFinishMonitor",
                                      "下载完成监控",
                                      index1,
                                      {
                                        required: !!item.required,
                                        min: item.data.minLen,
                                        max: item.data.maxLen
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.downloadFinishMonitor[index1],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.downloadFinishMonitor,
                                      index1,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.downloadFinishMonitor[index1]"
                                }
                              },
                              [
                                index1 > 0
                                  ? _c("el-button", {
                                      attrs: {
                                        slot: "append",
                                        icon: "el-icon-close"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteValue(
                                            "downloadFinishMonitor",
                                            index1
                                          )
                                        }
                                      },
                                      slot: "append"
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "-60px",
                                left: "0"
                              },
                              attrs: { type: "primary", plain: "" },
                              on: {
                                click: function($event) {
                                  return _vm.setUrlInput(
                                    "downloadFinishMonitor"
                                  )
                                }
                              }
                            },
                            [_vm._v("添加URL")]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              position: "absolute",
                              top: "12px",
                              left: "101%",
                              "font-size": "20px",
                              cursor: "pointer"
                            },
                            attrs: { title: "点击查看宏参数列表" },
                            on: {
                              click: function($event) {
                                return _vm.openMacroDialog(false)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.downloadFinishMonitor }
                          })
                        ],
                        2
                      )
                    : item.assetsId === 25
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          class: { "is-required": !!item.required },
                          staticStyle: {
                            width: "500px",
                            "margin-bottom": "80px"
                          },
                          attrs: {
                            label: "安装开始监控",
                            prop: "installStartMonitor",
                            error: _vm.installStartMonitorTip
                          }
                        },
                        [
                          _vm._l(_vm.form.installStartMonitor, function(
                            item1,
                            index1
                          ) {
                            return _c(
                              "el-input",
                              {
                                key: index1,
                                staticClass: "mt10",
                                on: {
                                  blur: function($event) {
                                    return _vm.urlRule(
                                      "installStartMonitor",
                                      "安装开始监控",
                                      index1,
                                      {
                                        required: !!item.required,
                                        min: item.data.minLen,
                                        max: item.data.maxLen
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.installStartMonitor[index1],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.installStartMonitor,
                                      index1,
                                      $$v
                                    )
                                  },
                                  expression: "form.installStartMonitor[index1]"
                                }
                              },
                              [
                                index1 > 0
                                  ? _c("el-button", {
                                      attrs: {
                                        slot: "append",
                                        icon: "el-icon-close"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteValue(
                                            "installStartMonitor",
                                            index1
                                          )
                                        }
                                      },
                                      slot: "append"
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "-60px",
                                left: "0"
                              },
                              attrs: { type: "primary", plain: "" },
                              on: {
                                click: function($event) {
                                  return _vm.setUrlInput("installStartMonitor")
                                }
                              }
                            },
                            [_vm._v("添加URL")]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              position: "absolute",
                              top: "12px",
                              left: "101%",
                              "font-size": "20px",
                              cursor: "pointer"
                            },
                            attrs: { title: "点击查看宏参数列表" },
                            on: {
                              click: function($event) {
                                return _vm.openMacroDialog(false)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.installStartMonitor }
                          })
                        ],
                        2
                      )
                    : item.assetsId === 26
                    ? _c(
                        "el-form-item",
                        {
                          key: index,
                          class: { "is-required": !!item.required },
                          staticStyle: {
                            width: "500px",
                            "margin-bottom": "80px"
                          },
                          attrs: {
                            label: "安装完成监控",
                            prop: "installFinishMonitor",
                            error: _vm.installFinishMonitorTip
                          }
                        },
                        [
                          _vm._l(_vm.form.installFinishMonitor, function(
                            item1,
                            index1
                          ) {
                            return _c(
                              "el-input",
                              {
                                key: index1,
                                staticClass: "mt10",
                                on: {
                                  blur: function($event) {
                                    return _vm.urlRule(
                                      "installFinishMonitor",
                                      "安装完成监控",
                                      index1,
                                      {
                                        required: !!item.required,
                                        min: item.data.minLen,
                                        max: item.data.maxLen
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.installFinishMonitor[index1],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.installFinishMonitor,
                                      index1,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.installFinishMonitor[index1]"
                                }
                              },
                              [
                                index1 > 0
                                  ? _c("el-button", {
                                      attrs: {
                                        slot: "append",
                                        icon: "el-icon-close"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteValue(
                                            "installFinishMonitor",
                                            index1
                                          )
                                        }
                                      },
                                      slot: "append"
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "-60px",
                                left: "0"
                              },
                              attrs: { type: "primary", plain: "" },
                              on: {
                                click: function($event) {
                                  return _vm.setUrlInput("installFinishMonitor")
                                }
                              }
                            },
                            [_vm._v("添加URL")]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              position: "absolute",
                              top: "12px",
                              left: "101%",
                              "font-size": "20px",
                              cursor: "pointer"
                            },
                            attrs: { title: "点击查看宏参数列表" },
                            on: {
                              click: function($event) {
                                return _vm.openMacroDialog(false)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("ChangeTips", {
                            attrs: { change: _vm.changes.installFinishMonitor }
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              }),
              _vm._v(" "),
              _vm.form.unit.indexOf(":8") > -1
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "生效时间",
                          prop: "effectTime",
                          rules: [
                            {
                              required: true,
                              message: "请选择生效时间",
                              trigger: "change"
                            }
                          ]
                        }
                      },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            placeholder: "选择日期时间"
                          },
                          model: {
                            value: _vm.form.effectTime,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "effectTime", $$v)
                            },
                            expression: "form.effectTime"
                          }
                        }),
                        _vm._v(" "),
                        _c("ChangeTips", {
                          attrs: { change: _vm.changes.effectTime }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "过期时间",
                          prop: "expiredTime",
                          rules: [
                            {
                              required: true,
                              message: "请选择过期时间",
                              trigger: "change"
                            }
                          ]
                        }
                      },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            placeholder: "选择日期时间"
                          },
                          model: {
                            value: _vm.form.expiredTime,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "expiredTime", $$v)
                            },
                            expression: "form.expiredTime"
                          }
                        }),
                        _vm._v(" "),
                        _c("ChangeTips", {
                          attrs: { change: _vm.changes.expiredTime }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "前台显示概率",
                          prop: "showRatio",
                          rules: [
                            {
                              required: true,
                              message: "请选择前台显示概率",
                              trigger: "change"
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.form.showRatio,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "showRatio", $$v)
                              },
                              expression: "form.showRatio"
                            }
                          },
                          _vm._l(_vm.showRatioList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { value: item }
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("ChangeTips", {
                          attrs: { change: _vm.changes.showRatio }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.form.executeTime, function(item, index) {
                      return _c(
                        "el-form-item",
                        {
                          key: item.key,
                          attrs: {
                            label: "执行时间" + index,
                            prop: "executeTime." + index + ".value",
                            rules: [
                              {
                                required: true,
                                message: "请选择执行时间",
                                trigger: "change"
                              }
                            ]
                          }
                        },
                        [
                          _c("el-time-picker", {
                            model: {
                              value: item.value,
                              callback: function($$v) {
                                _vm.$set(item, "value", $$v)
                              },
                              expression: "item.value"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100px" },
                              model: {
                                value: item.radio,
                                callback: function($$v) {
                                  _vm.$set(item, "radio", $$v)
                                },
                                expression: "item.radio"
                              }
                            },
                            _vm._l(_vm.ratioList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item + "%", value: item }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeItem(item)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c("el-button", { on: { click: _vm.addItem } }, [
                          _vm._v("新增执行时间")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "拉活触发策略",
                          prop: "triggerWay",
                          rules: [
                            {
                              required: true,
                              message: "请选择拉活触发策略",
                              trigger: "change"
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.form.triggerWay,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "triggerWay", $$v)
                              },
                              expression: "form.triggerWay"
                            }
                          },
                          _vm._l(_vm.myOption.triggerWay, function(
                            item,
                            index
                          ) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("ChangeTips", {
                          attrs: { change: _vm.changes.triggerWay }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.triggerWay === 1,
                            expression: "form.triggerWay===1"
                          }
                        ],
                        attrs: {
                          label: "定时触发策略",
                          prop: "timeWay",
                          rules: [
                            {
                              required:
                                _vm.form.triggerWay === 1 ? true : false,
                              message: "请选择定时触发策略",
                              trigger: "change"
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.form.timeWay,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "timeWay", $$v)
                              },
                              expression: "form.timeWay"
                            }
                          },
                          _vm._l(_vm.myOption.timeWay, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("ChangeTips", {
                          attrs: { change: _vm.changes.timeWay }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.form.triggerWay === 1 &&
                              _vm.form.timeWay === 1,
                            expression: "form.triggerWay===1&&form.timeWay===1"
                          }
                        ],
                        attrs: {
                          label: _vm.myOption.timeWay[0].name,
                          prop: "speedTimes",
                          rules: [
                            {
                              required: _vm.form.timeWay === 1 ? true : false,
                              message: "请选择" + this.myOption.timeWay[0].name,
                              trigger: "change"
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.form.speedTimes,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "speedTimes", $$v)
                              },
                              expression: "form.speedTimes"
                            }
                          },
                          _vm._l(_vm.speedTimesList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { value: item }
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("ChangeTips", {
                          attrs: { change: _vm.changes.speedTimes }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.form.triggerWay === 1 &&
                              _vm.form.timeWay === 2,
                            expression: "form.triggerWay===1&&form.timeWay===2"
                          }
                        ],
                        attrs: {
                          label: _vm.myOption.timeWay[1].name,
                          prop: "timeBucket",
                          rules: [
                            {
                              required: _vm.form.timeWay === 2 ? true : false,
                              message: "请选择" + this.myOption.timeWay[1].name,
                              trigger: "change"
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.form.timeBucket,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "timeBucket", $$v)
                              },
                              expression: "form.timeBucket"
                            }
                          },
                          _vm._l(_vm.timeBucketList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { value: item }
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("ChangeTips", {
                          attrs: { change: _vm.changes.timeBucket }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "每日最大展示数", prop: "dayShowNum" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.dayShowNum,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "dayShowNum", $$v)
                      },
                      expression: "form.dayShowNum"
                    }
                  }),
                  _vm._v(" "),
                  _c("ChangeTips", {
                    attrs: { change: _vm.changes.dayShowNum }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "每日最大点击数", prop: "dayClickNum" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.dayClickNum,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "dayClickNum", $$v)
                      },
                      expression: "form.dayClickNum"
                    }
                  }),
                  _vm._v(" "),
                  _c("ChangeTips", {
                    attrs: { change: _vm.changes.dayClickNum }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "备注", prop: "remark" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark"
                    }
                  }),
                  _vm._v(" "),
                  _c("ChangeTips", { attrs: { change: _vm.changes.remark } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  !_vm.isViewMode && !_vm.isAuditMode
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitForm("form")
                            }
                          }
                        },
                        [_vm._v("提交")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isViewMode && !_vm.isAuditMode && _vm.isModel !== 2
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.resetForm("form")
                            }
                          }
                        },
                        [_vm._v("重置")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _vm.isAuditMode && _vm.isSspUser ? _c("el-divider") : _vm._e(),
          _vm._v(" "),
          _vm.isAuditMode && _vm.isSspUser
            ? _c(
                "el-form",
                {
                  ref: "auditForm",
                  attrs: { model: _vm.auditForm, "label-width": "150px" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "500px" },
                      attrs: {
                        label: "是否通过",
                        prop: "auditResult",
                        error: _vm.auditResultTip
                      }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.auditForm.auditResult,
                            callback: function($$v) {
                              _vm.$set(_vm.auditForm, "auditResult", $$v)
                            },
                            expression: "auditForm.auditResult"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("通过")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("不通过")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "500px" },
                      attrs: { label: "原因", prop: "auditReason" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          maxlength: "100",
                          "show-word-limit": "",
                          placeholder: "请输入原因"
                        },
                        model: {
                          value: _vm.auditForm.auditReason,
                          callback: function($$v) {
                            _vm.$set(_vm.auditForm, "auditReason", $$v)
                          },
                          expression: "auditForm.auditReason"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitForm("form", 1)
                            }
                          }
                        },
                        [_vm._v("提交")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "宏参数列表",
                visible: _vm.showMacroDialog,
                width: "1110px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showMacroDialog = $event
                }
              }
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.macroList, height: "50vh" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "宏参数", width: "200" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "desc", label: "参数描述", width: "800" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63b48d62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63b48d62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/idea/Edit.vue
// module id = EwT2
// module chunks = 1